<template>
  <h1>PENGINAPAN</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>